import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Cards from './components/Cards';
import IndexModule from './components/IndexModule';
import About from './components/About';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Ranking from './components/Ranking';
import AppModule from './components/AppModule';
import Updates from './components/Updates';
import Comments from './components/Comments';
import Media from './components/Media';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Cards />
        <IndexModule />
        <About />
        <Topics />
        <Carousel />
        <Contact />
        <Ranking />
        <AppModule />
        <Updates />
        <Comments />
        <Media />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}